import { i18nResource } from "../../i18nResource.interface";

const section7: i18nResource.Section7 = {
    title: "PATNERS (TBD)",
};

export default section7;
